import { Box } from '@chakra-ui/react';
import React from 'react';

import { BorrowerHomeView } from 'borrower/domains/page/ui/BorrowerHomeView';

import 'source/borrower/borrower.scss';

export const BorrowerHomeRoute = () => {
  return (
    <Box className="main">
      <BorrowerHomeView />
    </Box>
  );
};
